import { V2Spinner, V2Typography } from "@cakewalk/ui/v2";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * QuickBooks OAuth popup callback. Reached inside the popup after Intuit
 * redirects to apps/api's `/quickbooks/callback`, which (after exchanging the
 * code, pulling the roster/payroll/company info, and persisting it) 302s the
 * popup here with `?oauth=success|error`. This page relays the outcome to the
 * opener (the census flow) via `postMessage` and closes itself.
 */
export function OAuthQuickBooksCallbackPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const status = searchParams.get("oauth") === "success" ? "success" : "error";
    const error = searchParams.get("error") ?? undefined;

    if (window.opener) {
      // Target origin "*" — the opener (the census flow) may be served from a
      // different host than this callback (e.g. the raw *.amplifyapp.com domain
      // vs the census.dev custom domain), and we can't read the opener's origin
      // cross-window. The payload carries no secrets (just success/error), and
      // the opener validates the message by source window + type, not origin.
      window.opener.postMessage({ type: "quickbooks-oauth", status, error }, "*");
    }
    const timer = window.setTimeout(() => window.close(), 1200);
    return () => window.clearTimeout(timer);
  }, [searchParams]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-cw-v2-surface px-6 text-center">
      <V2Spinner size="md" />
      <V2Typography variant="body" className="font-semibold">
        Finishing up with QuickBooks…
      </V2Typography>
      <V2Typography variant="meta" muted>
        This window will close automatically.
      </V2Typography>
    </div>
  );
}
